import 'consumerweb-shim';
import 'adsinterceptor';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import { Header, Footer } from 'marketing-components';
import {
  CaptionText,
  grey600,
  HeadingText,
  BodyText,
} from '@paypalcorp/pp-react';
import glamorous from 'glamorous';
import CategoryTiles from '../components/categoryTiles/categoryTiles';

import * as analytics from '../lib/analytics';

import SearchBox from '../components/searchBox';
import CharityList from '../components/charityList';
import HubSocialShare from '../components/HubSocialShare';
import Confirmation from '../components/confirmation';
import CheckoutError from '../components/checkoutError';
import DonationSteps from '../components/donation-steps';
import Stripe from '../components/stripe';
import AdBanner from '../components/adBanner/adBanner';
import FeaturedCharityContainer from '../components/hubFeaturedCharityContainer/hubFeaturedCharityContainer';

import content from '../lib/i18n';
import { isPPGF } from '../lib/charity';
import styles from './hubLanding.less';
import { DataContext } from '../lib/context';
const i18n = content('hubLanding');

if (window.PAYPAL && window.PAYPAL.analytics) {
  window.PAYPAL.analytics.startClientErrorTracking();
}

import { HUB_PAGE_GROUP, HUB_PAGE_LANDING } from '../lib/fptiTrackingVariables';

const LegalText = glamorous(CaptionText)({
  color: grey600,
});

class Page extends React.Component {
  static propTypes = {
    csrf: PropTypes.string,
    featured: PropTypes.array,
    categories: PropTypes.array,
    donationInfo: PropTypes.object,
  };

  static childContextTypes = {
    csrf: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);

    var initialState = {
      fptiInfo: {
        pgrp: HUB_PAGE_GROUP,
        page: HUB_PAGE_LANDING,
      },
      isMobile: false,
    };
    this.state = initialState;
  }

  parseFPTIInfo = (fptiData) => {
    var nameValues = [];
    var pairs = decodeURIComponent(fptiData).split('&');
    var i;
    for (i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  componentDidMount() {
    let isMobile = false;
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
      this.setState({
        isMobile,
      });
    }

    // to replace the default /signin href from marketing header
    // we need it to go back to npo page
    const marketingULButton = document.getElementById('ul-btn') || {};
    marketingULButton.href = this.props.unifiedLoginURL;
  }

  getChildContext() {
    return {
      csrf: this.props.csrf,
    };
  }

  handleAnalytics = (click) => {
    analytics.trackLink(
      click,
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      'link'
    );
  };

  renderFooter = () => {
    const { content: footerContent, localeCountry } = JSON.parse(
      document.getElementById('data-footer').innerHTML
    );
    return (
      <Footer
        content={footerContent}
        localeCountry={localeCountry}
        flagHref={`https://www.${
          this.props.domain
        }/${localeCountry.toLowerCase()}/webapps/mpp/country-worldwide`}
      />
    );
  };

  renderHeader = () => {
    const { contentLoggedOut: content, config } = JSON.parse(
      document.getElementById('data-header').innerHTML
    );
    const props = { content, config };
    return (
      <div className={'marketing-header-background'}>
        <Header {...props} />
      </div>
    );
  };

  render() {
    const heroImageHeader = i18n('label.hub-title');
    const heroImageSubheader = i18n('label.hub-subtitle');
    const npoBaseUrl = '/fundraiser/charity/';
    const marginStyle =
      this.props.featured.length > 0 ? 'charityPanelMargin' : '';
    let charityList = (
      <CharityList
        {...this.props}
        fptiInfo={this.state.fptiInfo}
        i18n={i18n}
        charities={this.props.suggestedCharties}
      />
    );
    let selectedCharityIndexOnRedirect = -1;
    selectedCharityIndexOnRedirect = this.props.featured
      .map((charity) => charity.nonprofit_id)
      .indexOf(this.props.redirectPreferredNpid);

    return (
      <div>
        {this.props.mppHeader && this.renderHeader()}
        {this.props.isBannerEnabled &&
          i18n('label.banner-title').length > 1 && (
            <AdBanner fptiInfo={this.state.fptiInfo} i18n={i18n} />
          )}
        <div
          className={'mainHeroImage'}
          style={{
            background: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.15)), url(${i18n(
              'label.hero_image_url'
            )}) no-repeat`,
            backgroundSize: 'cover',
            position: 'relative',
            backgroundPosition: 'center center',
          }}
        >
          <div className={'innerHeroContainer'}>
            <div className={'heroContent'}>
              <HeadingText
                as='h1'
                size={this.state.isMobile ? 'md' : 'hero'}
                dangerouslySetInnerHTML={{
                  __html: heroImageHeader,
                }}
              />
              {this.state.isMobile ? (
                <BodyText
                  dangerouslySetInnerHTML={{
                    __html: heroImageSubheader,
                  }}
                />
              ) : (
                <HeadingText
                  as='h3'
                  size='sm'
                  dangerouslySetInnerHTML={{
                    __html: heroImageSubheader,
                  }}
                />
              )}
            </div>
            <div className={'searchBoxDiv'}>
              <SearchBox
                {...this.props}
                i18n={i18n}
                isMobile={this.state.isMobile}
                fptiInfo={this.state.fptiInfo}
                searchSubmitUrl={`${this.props.coBrand}hub`}
              />
            </div>
          </div>
        </div>
        {this.props.donationInfo && this.props.donationInfo.donated === 1 && (
          <Confirmation
            title={i18n('label.conf-title')}
            subTitle={i18n('label.conf-subTitle')}
            fptiInfo={this.state.fptiInfo}
            npid={this.props.donationInfo.npid}
            npoUrl={this.props.donationInfo.url}
            i18n={i18n}
            cdnHost={this.props.cdnHost}
          />
        )}
        {this.props.donationInfo && this.props.donationInfo.donated === 0 && (
          <CheckoutError
            i18n={i18n}
            fptiInfo={this.state.fptiInfo}
            cdnHost={this.props.cdnHost}
          />
        )}
        <Stripe
          fptiInfo={this.state.fptiInfo}
          isPPGF={isPPGF(allowedCharityType)}
          i18n={i18n}
          cdnHost={this.props.cdnHost}
        />
        {/* {this.renderNearByModule()} */}
        {this.props.featured.length > 0 && (
          <FeaturedCharityContainer
            i18n={i18n}
            hubFlow={true}
            coBrand={coBrand}
            isMobile={this.state.isMobile}
            npoBaseUrl={npoBaseUrl}
            fptiInfo={this.state.fptiInfo}
            selectedCharityIndexOnRedirect={selectedCharityIndexOnRedirect}
            featuredCharities={this.props.featured}
            isCountrySetPreferredSupported={
              this.props.isCountrySetPreferredSupported
            }
            preferredCharityNpid={this.props.preferredCharityNpid}
            authState={this.props.authState}
            unifiedLoginURL={this.props.unifiedLoginURL}
            userType={this.props.userType}
            csrf={this.props.csrf}
            amounts={this.props.amounts}
            cdnHost={this.props.cdnHost}
          />
        )}
        {!charityListUnderThreshold ? (
          <CategoryTiles
            id={'charityCategories'}
            categories={this.props.categories}
            coBrand={`${coBrand}hub`}
            fptiInfo={this.state.fptiInfo}
            maxTextLength={40}
            i18n={i18n}
          />
        ) : (
          <div
            className={`panel ${styles.charityPanel} ${styles[marginStyle]}`}
          >
            <HeadingText as='h3' size='lg' className={styles.charityListHeader}>
              {i18n('label.suggest-charities')}
            </HeadingText>
            {charityList}
          </div>
        )}
        {isPPGF(allowedCharityType) && (
          <DonationSteps i18n={i18n} cdnHost={this.props.cdnHost} />
        )}
        {/* {isPPGF(allowedCharityType) && (
          <FAQBanner fptiInfo={this.state.fptiInfo} i18n={i18n} />
        )} */}
        <HubSocialShare
          i18n={i18n}
          url={window.location.href}
          fptiInfo={this.state.fptiInfo}
          fbDesc={i18n('label.fb-share-msg')}
          fbTitle={i18n('label.fb-share-name')}
          cdnHost={this.props.cdnHost}
        />
        <div
          id={'gift'}
          className={'container'}
          style={{ marginTop: '20px', marginBottom: '20px' }}
        >
          <LegalText
            dangerouslySetInnerHTML={{
              __html: i18n('label.legal-footer-default'),
            }}
            as='p'
            size='xs'
          />
        </div>
        {this.props.mppFooter && this.renderFooter()}
      </div>
    );
  }
}

const hub = JSON.parse(document.getElementById('data-hub').innerHTML);

const data = JSON.parse(document.getElementById('data-props').innerHTML);
const authState = data.authState;
const resources = JSON.parse(
  document.getElementById('data-resources').innerHTML
);
const charityListUnderThreshold = data.charityListUnderThreshold;
const preferredCharityNpid = data.preferredCharityNpid;
const redirectPreferredNpid = data.redirectPreferredNpid;
const query = data.query;
const allowedCharityType = data.allowedCharityType;
const charities = data.charities;
const suggestedCharties = data.suggestedCharties;
const featured = data.featured;
const recommended = data.recommended || {};
const nearBy = data.nearBy;
const states = data.states;
const categories = data.categories;
const labels = data.labels;
const donation = data.donation;
const donationInfo = data.donationInfo;
const mppFooter = data.mppFooter;
const mppHeader = data.mppHeader;
const amounts = data.amounts;
const unifiedLoginURL = data.unifiedLoginURL;
const isCountrySetPreferredSupported = data.isCountrySetPreferredSupported;
const userType = data.userType;
const cdnHost = data.cdnHost;
const domain = data.domain;
const isBannerEnabled = data.isBannerEnabled;
const searchUrl = document.getElementById('data-search-url').innerHTML;
const csrf = document.getElementById('data-csrf').innerHTML;
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);
const coBrand = document.getElementById('data-co-brand').innerHTML;
const charityUrl = `${coBrand}charity`;
const deviceType = JSON.parse(
  document.getElementById('data-deviceType').innerHTML
);
const hubUrl = `https://www.${domain}${coBrand}hub`;

ReactDOM.render(
  <DataContext.Provider value={data}>
    <Page
      query={query}
      charities={charities}
      isCountrySetPreferredSupported={isCountrySetPreferredSupported}
      preferredCharityNpid={preferredCharityNpid}
      authState={authState}
      redirectPreferredNpid={redirectPreferredNpid}
      userType={userType}
      cdnHost={cdnHost}
      domain={domain}
      isBannerEnabled={isBannerEnabled}
      charityListUnderThreshold={charityListUnderThreshold}
      suggestedCharties={suggestedCharties}
      featured={featured}
      amounts={amounts}
      nearBy={nearBy}
      csrf={csrf}
      searchUrl={searchUrl}
      charityUrl={charityUrl}
      fptiInfo={fptiInfo}
      categories={categories}
      states={states}
      coBrand={coBrand}
      recommended={recommended}
      resources={resources}
      labels={labels}
      donation={donation}
      deviceType={deviceType}
      donationInfo={donationInfo}
      hubUrl={hubUrl}
      hub={hub}
      unifiedLoginURL={unifiedLoginURL}
      mppFooter={mppFooter}
      mppHeader={mppHeader}
    />
  </DataContext.Provider>,
  document.getElementById('page')
);
